module.exports = __webpack_public_path__ + "static/media/Frete-04.aa75d700.svg";